import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'antd/lib/modal/Modal';
import { useForm, Controller } from 'react-hook-form';
import { Button, Input } from 'antd';

import Api from '../Api';
import { errorNotification, successNotification } from '../Snackbar';
import GetField from '../Components/GetField';

const AntInput = GetField(Input);
const AntInputTextArea = GetField(Input.TextArea);

const ApproveModal = props => {
  const { recordId, modalType, hideModal } = props;

  const [confirmLoading, setConfirmLoading] = useState(false);

  const { control, handleSubmit, reset } = useForm();

  const onSubmit = useCallback(async formValues => {
    try {
      setConfirmLoading(true);
      await Api.post(
        `/fabric-inventory/transfer/${recordId}/approve`,
        formValues
      );
      reset();
      successNotification('Transfer approved');
      hideModal();
    } catch (err) {
      setConfirmLoading(false);
      errorNotification(err);
    }
  }, []);

  return (
    <Modal
      visible={modalType === 'Approve'}
      onCancel={hideModal}
      centered
      title="Approve"
      width="40%"
      maskClosable={false}
      footer={false}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name="transferredQuantity"
          control={control}
          render={({ field }) => (
            <AntInput
              allowClear
              type="number"
              min={0}
              step="any"
              label="Quantity"
              placeholder="Quantity"
              {...field}
            />
          )}
        />
        <Controller
          name="respondedRemark"
          control={control}
          render={({ field }) => (
            <AntInputTextArea
              allowClear
              label="Remark"
              placeholder="Remark"
              {...field}
            />
          )}
        />
        <Button type="primary" loading={confirmLoading} htmlType="submit">
          Submit
        </Button>
      </form>
    </Modal>
  );
};

ApproveModal.propTypes = {
  recordId: PropTypes.number,
  modalType: PropTypes.string,
  hideModal: PropTypes.func,
};

export default ApproveModal;
